import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Home from "./Home";
import KrHome from "./KrHome";
import OneTimePayment from "./OneTimePayment";
import KrPaymentSuccess from "./KrPaymentSuccess";
import PaymentSuccess from "./PaymentSuccess";

const PaymentPage = () => {
  const params = new URLSearchParams(window.location.search);
  const locale = params.get("lang");

  if (locale === "ko" || locale === "kr") {
    return <KrHome />;
  }
  return <Home />;
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PaymentPage />} />
        <Route path="/payment" element={<PaymentPage />} />

        <Route path="/one-time-payment" element={<OneTimePayment />} />

        <Route
          path="/mobile"
          element={
            <Navigate to={`/?${window.location.search.slice(1)}`} replace />
          }
        />
        <Route path="/kr-payment-success" element={<KrPaymentSuccess />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
      </Routes>
    </Router>
  );
};

export default App;
